import type {SubscriptionState} from './subscriptionTypes';

export const createSubscriptionState = (): SubscriptionState => ({
  socket: null,
  detachCurrentSocket: undefined,
  reopenSocket: undefined,
  reconnectTimer: undefined,
  isCleaningUp: false,
  isRefreshing: false,
  hasStopped: false,
  reconnectAttempts: 0,
  reauthAttempts: 0,
  hasConnected: false,
});
